import * as Yup from "yup";
import moment from "moment";
import {ReportPaymentPayload} from "interfaces";

export const initialValues: ReportPaymentPayload = {
  id: "",
  dni: "",
  phone: "",
  capture: "",
  bank_id: "",
  reference: "",
  finanza_id: "",
  formulario_id: "",
  reported_amount: "",
  reported_date: moment().format("YYYY-MM-DD"),
};

export const reportPaymentSchema = Yup.object().shape({
  dni: Yup.string().required("El DNI es requerido"),
  phone: Yup.string().required("El teléfono es requerido"),
  bank_id: Yup.string().required("El banco es requerido"),
  reported_amount: Yup.string().required("El monto es requerido"),
  reference: Yup.string().required("La referencia es requerida"),
});
